import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class AddEditPartyService {
  placeResourcesFitBySizeFirst<T extends {capacity: {min: number, max: number}}>(resources: T[], size: number): T[] {
    const fit: T[] = [];
    const dontFit: T[] = [];
    for (const resource of resources) {
      if (resource.capacity.min <= size && size <= resource.capacity.max) {
        fit.push(resource);
      } else {
        dontFit.push(resource);
      }
    }

    return [...fit, ...dontFit];
  }
}
